import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, computed, useStore, useContext } from '@nuxtjs/composition-api';
import Vue from 'vue';
import TInput from '~/components/atoms/t-input.vue';
import { State } from '~/store';

interface Props {
  labelText: string;
  error?: string | undefined;
}

interface Emits {
  (event: 'onApply', value: string | undefined): void;
  (event: 'resetError'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralCodeInput',
  props: {
    labelText: null,
    error: null
  },
  emits: ["onApply", "resetError"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'onApply', value: string | undefined): void;
  (event: 'resetError'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  labelText: string;
  error?: string | undefined;
};

const { $isFlagOn } = useContext();
const store = useStore<State>();


const recurlyDiscount = ref<string | null>(null);
const referralCodeValue = ref<string | null>(null);
const isOpen = ref(false);
const validationError = ref<string | null>(null);
const formError = computed(() => props.error || validationError.value);
const incomingReferralCode = computed(() => store.getters.currentReferralCode);

onMounted(() => {
  if (incomingReferralCode.value && $isFlagOn('saasquatch-integration')) {
    referralCodeValue.value = incomingReferralCode.value;
    toggleOpen();
    apply().catch(console.error);
  }
});

const apply = async () => {
  const normalisedReferralCode = referralCodeValue.value?.trim();
  const invalidChars = normalisedReferralCode?.match(/[./\\`#]/);
  if (invalidChars) {
    validationError.value = `Invalid character: ${invalidChars[0]}`;
    return;
  }
  referralCodeValue.value = normalisedReferralCode || null;
  validationError.value = null;
  emit('resetError');
  await Vue.nextTick();
  emit('onApply', referralCodeValue.value || undefined);
};

const reset = async () => {
  referralCodeValue.value = null;
  await apply();
};

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

watch(referralCodeValue, () => {
  if (!referralCodeValue.value) {
    apply().catch(console.error);
  }
});

return { __sfc: true,$isFlagOn, store, props, emit, recurlyDiscount, referralCodeValue, isOpen, validationError, formError, incomingReferralCode, apply, reset, toggleOpen, TInput }
}

})